import { Typography , Dialog, DialogTitle, DialogContent, DialogActions, Button, List, ListItemButton, ListItemText } from "@mui/material";
import ReportPageShell from "../../../components/layouts/ReportPageShell";
import StatusChip from "../../../components/common/chips/StatusChip";
import DataGridTable from '../../../components/tables/DataGridTable';
import { useReportData } from '../../../hooks/data/useReportData';
import { useNavigate } from "react-router-dom";
import { useState, useMemo } from 'react';
import Cookies from 'js-cookie';
import './shipmentstatus.css';

const reportMapper = {
  Truwear: 'truware shipment status report',
  'GTMS-CP': 'demo shipment status report'
};

const subReportMapper = {
  Truwear: 'truware sub level',
  'GTMS-CP': 'demo sub level' 
};

const ShipmentStatusReport = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const customer = Cookies.get('cp-cn');
  const report = reportMapper?.[customer];
  const subReport = subReportMapper[customer];

  let response = useReportData(report, 250);
  const { data = [] } = response?.data ?? {};

  const statuses = [...new Set(data.map(r => r.STATUS || 'Unknown'))];
  const columns = useMemo(() => {
    if (!data.length) return [];

    return Object.keys(data[0]).map((key) => ({
      field: key,
      headerName: key.replace(/_/g, ' '),
      flex: 1,
    }));
  }, [data]);

  const handleRowClick = (params) => {
    setSelectedId(params.row.ID);
    setOpen(true);
  };

  // const subResp = useReportData(
  //   selectedId ? "truware sub level" : null, 100, selectedId ? { id: selectedId } : {}
  // );

    const subResp = useReportData(
      selectedId && subReport ? subReport : null,
      100,
      selectedId ? { id: selectedId } : {}
    );

  const subData = subResp?.data?.data ?? [];

  const handlePick = (item) => {
    setOpen(false);
    navigate(`/statusdetails/${item.ID}`, { state: { item }});
  };

  return (
      <>
    <ReportPageShell title='Shipment Status'>
      <div className="reportSpace" style={{ overflowY: 'auto', overflowX: 'hidden' }}>
        {statuses.map(status => (
          <div key={status}>
            <h3 className="shipmentStatusSectionHeader">
              {status.toLowerCase().replace(/\b\w/g, c => c.toUpperCase())}
            </h3>
            <div className="statusSectionBody">
            <DataGridTable 
              rows={data.filter(r => (r.STATUS || 'Unknown') === status)}
              columns={columns}
              getRowId={(row) => row.ID ?? row.PO_NUMBER} 
              onRowClick={handleRowClick}
              renderers={{ STATUS: (params) => <StatusChip value={params.value} />, }}
            />
          </div>
          </div>
        ))}
      </div>
    </ReportPageShell>
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth="sm"
    >
    <DialogTitle>Select an option</DialogTitle>
    <DialogContent dividers>
      {subData.length === 0 ? (
        <Typography variant="body2">Loading…</Typography>
      ) : (
        <List dense>
          {subData.map((item) => (
            <ListItemButton
              key={item.ID}
              onClick={() => handlePick(item)}
            >
              <ListItemText
                primary={item.NAME}
                secondary={item.STATUS}
              />
            </ListItemButton>
          ))}
        </List>
      )}
    </DialogContent>

    <DialogActions>
      <Button onClick={() => setOpen(false)}>Cancel</Button>
    </DialogActions>
  </Dialog>
  </>
  )
}

export default ShipmentStatusReport
